module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.31ad6e1.woff2";